import { render } from "./nest-success.vue?vue&type=template&id=22c20bd2"
import script from "./nest-success.vue?vue&type=script&lang=js"
export * from "./nest-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__